// extracted by mini-css-extract-plugin
export default {"l_EditRequestView_TextareaContainer":"EditRequestView_l_EditRequestView_TextareaContainer__VBLN9"};